import { gql } from 'apollo-angular';

import { ACCOUNT_PROFILE_FRAGMENT } from 'graphql/fragments/account-profile';
import { CONDITION_FRAGMENT } from 'graphql/fragments/condition';
import { CONTACT_PERSON_BASE_FRAGMENT } from 'graphql/fragments/contact-person-base';
import { CUSTOMER_BASE_FRAGMENT } from 'graphql/fragments/customer-base';
import { OBJECT_BASE_FRAGMENT } from 'graphql/fragments/object-base';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';

export const OFFER_BASE_FRAGMENT = gql`
  fragment OfferBaseFragment on Quote {
    documentId
    revision
    title
    locked
    createdDate
    validTo
    status
    salesArea {
      id
      name
    }
    partner(partnerRole: SoldTo) {
      externalId
    }
    customer {
      useCustomConditions
      ...CustomerBaseFragment
      conditions {
        ...ConditionFragment
      }
      contactPersons {
        id
      }
    }
    contactPerson {
      ...ContactPersonBaseFragment
    }
    object {
      ...ObjectBaseFragment
    }
    textTemplateId: customProperty(key: "TextTemplateId") { stringValue }
    textTemplatePreText: customProperty(key: "TextTemplate1") { stringValue }
    textTemplatePostText: customProperty(key: "TextTemplate2") { stringValue }
    dealerOfferTitle: customProperty(key: "DealerOfferTitle") { stringValue }
    manufacturerOfferTitle: customProperty(key: "ManufacturerOfferTitle") { stringValue }
    branchId: customProperty(key: "BranchID") { stringValue }
    sendMessage: customProperty(key: "SendMessage") { stringValue }
    calculationType: customProperty(key: "CalculationType") { stringValue }
    isTempOffer: customProperty(key: "IsTempConfig") { booleanValue }
    objectId: customProperty(key: "ObjectID") { stringValue }
    dealerObjectId: customProperty(key: "DealerObjectID") { stringValue }
    manufacturerObjectId: customProperty(key: "ManufacturerObjectID") { stringValue }
    createdFromRevision: customProperty(key: "CreatedFromRevision") { integerValue }
    createdByType # TODO: DIT-713: might need to re-add alias
    snkCreator{
      ...AccountProfileFragment
    }
    snkModifier{
      ...AccountProfileFragment
    }
    commission: customProperty(key: "Commission") { stringValue }
    ...QuotePricingStateFragment
  }
  ${CUSTOMER_BASE_FRAGMENT}
  ${CONDITION_FRAGMENT}
  ${CONTACT_PERSON_BASE_FRAGMENT}
  ${OBJECT_BASE_FRAGMENT}
  ${ACCOUNT_PROFILE_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;
